import { ColumnDef } from "@tanstack/react-table";

export interface UsageRow {
  id: string;
  keyName: string;
  addresses: number;
  buildings: number;
  batches: number;
  maps: number;
  landparcels: number;
  predictive: number;
  esri: number;
  clip: number;
  adminbounds: number;
}

export const cols: ColumnDef<UsageRow>[] = [
  { id: "keyName", accessorKey: "keyName", header: "API Key", size: 200 },
  {
    id: "addresses",
    accessorKey: "addresses",
    header: "Addresses API",
    size: 110,
  },
  {
    id: "buildings",
    accessorKey: "buildings",
    header: "Buildings API",
    size: 110,
  },
  { id: "batches", accessorKey: "batches", header: "Batches API", size: 110 },
  { id: "maps", accessorKey: "maps", header: "Maps API", size: 110 },
  {
    id: "landparcels",
    accessorKey: "landparcels",
    header: "Land Parcels API",
    size: 110,
  },
  {
    id: "predictive",
    accessorKey: "predictive",
    header: "Predictive API",
    size: 110,
  },
  {
    id: "esri",
    accessorKey: "esri",
    header: "Esri Compatible Locator",
    size: 110,
  },
  { id: "clip", accessorKey: "clip", header: "Clip", size: 80 },
  {
    id: "adminbounds",
    accessorKey: "adminbounds",
    header: "Administrative Boundaries API",
    size: 150,
  },
];
